import React from 'react';
import { SchemaRelationTypeGroup } from '../../interfaces/schemaRelations';
import { NodeLogo } from '@hevoio/hevo-ui-toolkit';
import RoundedIcon from '../../../../media/components/rounded-icon/RoundedIcon';

function RelationGroupTrigger({ relationGroup }: { relationGroup: SchemaRelationTypeGroup }) {
  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {relationGroup.meta.iconName ? (
        <RoundedIcon
          iconName={relationGroup.meta.iconName}
          containerSize={2}
          isIconColorWhite={false}
          hasBg={false}
          hasBorder
        />
      ) : (
        <NodeLogo
          roundedBorders
          size={1}
          logoURL={relationGroup.meta.logoUrl}
          darkModeLogoURL={relationGroup.meta.darkModeLogoUrl}
          primaryColor={relationGroup.meta.logoPrimaryColor}
          darkModePrimaryColor={relationGroup.meta.darkModePrimaryColor}
        />
      )}
    </>
  );
}

export default RelationGroupTrigger;
